import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';

export default function TestimonialSlider({ testimonials, testimonialBoxStyles, sliderSettings }) {
  return (
    <Box
      sx={{
        mt: 2,
        width: '100%',
        maxWidth: '1900px',
        mx: 'auto',
        // Match HeaderSection inner container horizontal padding
        px: { xs: 2.5, sm: 3, md: 3, lg: 15 },
        py: { xs: 1, sm: 2 },
        bgcolor: '#fff',
        boxSizing: 'border-box',
        // Subtle inner shadows on left and right edges
        // boxShadow:
        //   'inset 24px 0 24px -24px rgba(0,0,0,0.15), inset -24px 0 24px -24px rgba(0,0,0,0.15)'
      }}
    >
      <Slider {...sliderSettings}>
        {testimonials.map((imgSrc, idx) => (
          <Box key={idx} sx={{ px: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto' }}>
            <Box sx={testimonialBoxStyles}>
              <img src={imgSrc} alt={`Testimonial ${idx + 1}`} />
            </Box>
          </Box>
        ))}
      </Slider>
    </Box>
  );
}
